import {all, call, put, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {
  getHasNewMore,
  getMyNewsList,
  getThirdPartyTerms,
  getWaitfreeList,
  getAddedCashItems,
  getUsedCashItems,
  getAddedTicketHistory,
  getUsedTicketHistory,
  getAddedDaumCashItems,
  getUsedDaumCashItems,
} from './apiGet';
import {API_AUTH, getAccessToken} from '../../auth/common';
import {getUserId} from '../../auth/state/selector';
import {pAlert} from '../../common/component/PAlert';
import {
  APP_ONE_LINK,
  AUTH_HOST,
  BILLING_PATH,
  MORE_RED_DOT_LAST_DATE_TIME_KEY,
  REGION,
  UNKNOWN,
} from '../../common/constant';
import {Page} from '../../common/constant/page';
import {pToast} from '../../common/container/PToast';
import {selectT} from '../../common/i18n';
import {actions as commonActions} from '../../common/state/action';
import {ButtonSet} from '../../common/type/alert';
import callApi from '../../common/util/api';
import {IPagingParam, makeFetchSaga} from '../../common/util/fetch';
import {getQueryObject, routeTo} from '../../common/util/PageRouter';
import {typedSelect} from '../../common/util/saga';
import {getLocalStorageString} from '../../common/util/storage';
import {clearUserInfo} from '../../commonSub/function';

function* fetchCouponRegisterResult(
  action: ReturnType<typeof actions.fetchCouponRegisterResult>
) {
  const {
    payload: {redeemCode},
  } = action;

  const {success} = yield call(callApi, {
    url: `gift/v1/coupons/${redeemCode}`,
    method: 'post',
  });

  if (success) {
    yield put(actions.setValue('showSuccessCopuon', true));
  }
}

// TODO: 프랑스 리전 API 연동하기 복잡하면 global용 action 함수 하나 더 생성
function* fetchServiceWithdrawal() {
  yield put(commonActions.setValue('isOnLogout', true));
  const user = yield* typedSelect(state => state.auth.user);

  if (!user) {
    return;
  }

  const {success} = yield call(callApi, {
    apiHost: AUTH_HOST,
    url: `${API_AUTH}/auth/user`,
    method: 'delete',
    params: {
      access_token: user.accessToken,
    },
  });

  if (success) {
    pToast(t => t('more_myinfo_account_delete_toast'));
    clearUserInfo(true);
  }
}

function* fetchInquiry(action: ReturnType<typeof actions.fetchInquiry>) {
  const {
    email,
    phoneNumber,
    inquiryContents,
    inquiryTitle,
    fileList,
    categoryId,
    userAgent,
  } = action.payload;
  const user = yield* typedSelect(state => state.auth.user);
  const korFormData = fileList ? new FormData() : new URLSearchParams();

  const isKorea = REGION === 'kor';
  const headers = isKorea
    ? {
        auth_token: getAccessToken(),
        'content-type': fileList
          ? 'multipart/form-data'
          : 'application/x-www-form-urlencoded',
      }
    : undefined;
  // TODO: 카카오 쪽 api처럼와 데이터 맞춰달라고 하자. (급한 건 아님)
  const globalDatas: any = {};

  /**
   * 앱일 때는 userAgent.rawData에 kakaowebtoon/ 문자를 파싱해서 보내고,
   * 웹일 때는 userAgent 객체에 있는 값들을 사용해서 보낸다. (appVersion은 웹에서 제공 못함 그래서 빈 값)
   *
   * 웹에서 안드로이드 같은 경우에 deviceName이 unknown일 수 있기 때문에 unknown이면 Android로 보낸다.
   */
  if (userAgent) {
    const [appVersion, osVersion, deviceModel] = userAgent.rawData
      ?.split('kakaowebtoon/')[1]
      ?.split(' ')[0]
      ?.split(',') || [
      '',
      userAgent.osVersion,
      userAgent.deviceName === UNKNOWN ? 'Android' : userAgent.deviceName,
    ];

    if (isKorea) {
      korFormData.append('appVersion', appVersion);
      korFormData.append('osVersion', osVersion);
      korFormData.append('deviceModel', deviceModel);
    } else {
      globalDatas.appVersion = appVersion;
      globalDatas.osVersion = osVersion;
      globalDatas.deviceModel = deviceModel;
      globalDatas.browserName = userAgent.browserName;
    }
  }

  if (isKorea) {
    korFormData.append('sendEmail', email);
    korFormData.append('telNum', phoneNumber);
    korFormData.append('content', inquiryContents);
    korFormData.append('subject', inquiryTitle);
    korFormData.append('categoryId', categoryId || '');

    if (fileList) {
      fileList.forEach(file => {
        korFormData.append('files', file);
      });
    }
  } else {
    globalDatas.email = email;
    globalDatas.content = inquiryContents;
    globalDatas.categoryTitle = inquiryTitle;
    globalDatas.csId = user?.csId || '';
  }

  /**
   * 한국 문의하기 관련 카카오 API Document
   * https://wiki.daumkakao.com/pages/viewpage.action?pageId=333758059
   */
  const {success} = yield call(callApi, {
    url: '/customer-service/v1/inquiry',
    method: 'post',
    data: isKorea ? korFormData : globalDatas,
    headers,
  });

  if (success) {
    pToast(t => t('more_customer_inquiry_send_toast'));
  } else {
    pToast(t => t('more_customer_inquiry_send_failed_toast'));
  }
}

function* fetchToggleTerm(action: ReturnType<typeof actions.fetchToggleTerm>) {
  const {isAccepted, termId, termDate} = action.payload;
  const thirdPartyTerms = yield* typedSelect(
    state => state.more.thirdPartyTerms
  );

  const {success} = yield call(callApi, {
    apiHost: AUTH_HOST,
    url: `${API_AUTH}/auth/user/term`,
    method: 'POST',
    params: {
      access_token: getAccessToken(),
      agreed: isAccepted,
      term_of_use_id: termId,
      term_version: termDate,
    },
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });

  if (success) {
    yield put(
      actions.setValue(
        'thirdPartyTerms',
        thirdPartyTerms?.map(term => {
          if (term.termId === termId) {
            return {
              ...term,
              isAccepted,
            };
          }

          return term;
        })
      )
    );
  }
}

function* fetchThirdPartyTerms() {
  const {success, data} = yield call(callApi, {
    apiHost: AUTH_HOST,
    url: `${API_AUTH}/auth/user/term`,
    params: {
      access_token: getAccessToken(),
    },
  });

  if (success) {
    yield put(actions.setValue('thirdPartyTerms', getThirdPartyTerms(data)));
  }
}

function* fetchMoreRedDotStatus() {
  const userId = yield* typedSelect(getUserId);
  const moreRedDotLastDateTime = getLocalStorageString({
    key: MORE_RED_DOT_LAST_DATE_TIME_KEY,
  });

  const {success, data} = yield call(callApi, {
    url: 'notification/v1/last-read-time',
    params: {
      userId,
      newsLastReadDateTime: moreRedDotLastDateTime,
      waitForFreeLastReadDateTime: moreRedDotLastDateTime,
      noticeLastReadDateTime: moreRedDotLastDateTime,
    },
  });

  if (success) {
    yield put(actions.setValue('hasNewMore', getHasNewMore(data)));
  }
}

function* fetchMyNewsList(
  action: ReturnType<typeof actions.fetchMyNewsList>,
  params: IPagingParam
) {
  const t = yield* selectT();
  const userId = yield* typedSelect(getUserId);

  const {success, data} = yield call(callApi, {
    url: 'notification/v1/news',
    params: {
      ...params,
      userId,
    },
  });

  if (success) {
    yield put(actions.addMyNewsList(getMyNewsList(t, data), action.isFirst));
  }
}

function* fetchWaitfreeList(
  action: ReturnType<typeof actions.fetchWaitfreeList>,
  params: IPagingParam
) {
  const t = yield* selectT();

  const {success, data} = yield call(callApi, {
    url: 'ticket/v1/views/wait-for-free-timers',
    params,
  });

  if (success) {
    yield put(
      actions.addWaitfreeList(getWaitfreeList(t, data), action.isFirst)
    );
  }
}

function* fetchMyNewsReceive(
  action: ReturnType<typeof actions.fetchMyNewsReceive>
) {
  const userId = yield* typedSelect(getUserId);
  const {id, userAgent} = action.payload;

  const {success} = yield call(callApi, {
    url: 'notification/v1/news/read',
    method: 'post',
    data: {
      userId,
      id,
    },
  });
  if (success) {
    const myNewsList = yield* typedSelect(state => state.more.myNewsList);
    const myNews = myNewsList.find(myNews => myNews.id === id);

    if (myNews) {
      if (myNews.landingUrl?.includes('/notification')) {
        const {focus_id: focusId} = getQueryObject(myNews.landingUrl);
        routeTo({page: Page.MoreNotice, focusId: Number(focusId)});
      } else if (myNews.landingUrl?.includes('/cashfriends')) {
        if (userAgent.isMobile) {
          pAlert({
            buttonSet: ButtonSet.CancelAndConfirm,
            title:
              '해당 내용은 앱에서 확인 가능합니다.\n앱으로 이동하시겠습니까?',
          }).then(({okClicked}) => {
            okClicked && routeTo(APP_ONE_LINK);
          });
        } else {
          pToast('해당 내용은 앱에서 확인하실 수 있습니다.');
        }
      } else {
        myNews.landingUrl && routeTo(myNews.landingUrl);
      }
      yield put(actions.confirmMyNews(id));
    }
  }
}

function* fetchDeleteWaitfree() {
  const {selectedList, waitfreeList} = yield* typedSelect(state => ({
    selectedList: state.more.selectedList,
    waitfreeList: state.more.waitfreeList,
  }));

  const {success} = yield call(callApi, {
    method: 'delete',
    url: 'episode/v1/views/wait-for-free-timers',
    params: {
      ids: selectedList.join(','),
    },
  });

  if (success) {
    yield put(
      actions.setValue(
        'waitfreeList',
        waitfreeList.filter(waitfree => !selectedList.includes(waitfree.id))
      )
    );
    yield put(actions.setValue('selectedList', []));
  }
}

function* fetchCashHistory(
  action: ReturnType<typeof actions.fetchCashHistory>,
  params: IPagingParam
) {
  const {tab} = action.payload;
  const userId = yield* typedSelect(getUserId);
  const {success, data} = yield call(
    callApi,
    tab === 'added'
      ? {
          url: `/billing/v1/accounts/payments/${BILLING_PATH[REGION]}/${userId}`,
          params: {
            pageNo: 1,
            pageSize: 500,
            month: 6,
          },
        }
      : {
          url: '/history/v1/cash-used',
          params,
        }
  );
  if (success) {
    yield put(
      actions.addCashContents(
        tab === 'added'
          ? {
              tab,
              contents: getAddedCashItems(data),
            }
          : {
              tab,
              contents: getUsedCashItems(data),
            },
        action.isFirst
      )
    );
  }
}

function* fetchTicketHistory(
  action: ReturnType<typeof actions.fetchTicketHistory>,
  params: IPagingParam
) {
  const {tab} = action.payload;
  const {success, data} = yield call(callApi, {
    url:
      tab === 'added'
        ? '/history/v1/ticket-charged'
        : '/history/v1/ticket-used',
    params,
  });

  if (success && data) {
    yield put(
      actions.addTicketContents(
        tab === 'added'
          ? {
              tab: 'added',
              contents: getAddedTicketHistory(data),
            }
          : {
              tab: 'used',
              contents: getUsedTicketHistory(data),
            },
        action.isFirst
      )
    );
  }
}

function* fetchDaumCashHistory(
  action: ReturnType<typeof actions.fetchDaumCashHistory>,
  params: IPagingParam
) {
  const {tab} = action.payload;
  const {success, data} = yield call(
    callApi,
    tab === 'added'
      ? {
          url: '/history/v2/dw-cash',
          params,
        }
      : {
          url: '/history/v2/dw-order',
          params,
        }
  );

  if (success) {
    yield put(
      actions.addDaumCashContents(
        tab === 'added'
          ? {
              tab,
              contents: getAddedDaumCashItems(data),
            }
          : {
              tab,
              contents: getUsedDaumCashItems(data),
            },
        action.isFirst
      )
    );
  }
}

export default function* saga() {
  yield all([
    takeLeading(
      ActionType.FetchCouponRegisterResult,
      makeFetchSaga({fetchSaga: fetchCouponRegisterResult, canCache: false})
    ),
    takeLeading(
      ActionType.FetchServiceWithdrawal,
      makeFetchSaga({fetchSaga: fetchServiceWithdrawal, canCache: false})
    ),
    takeLeading(
      ActionType.FetchInquiry,
      makeFetchSaga({fetchSaga: fetchInquiry, canCache: false})
    ),
    takeLeading(
      ActionType.FetchToggleTerm,
      makeFetchSaga({fetchSaga: fetchToggleTerm, canCache: false})
    ),
    takeLeading(
      ActionType.FetchThirdPartyTerms,
      makeFetchSaga({fetchSaga: fetchThirdPartyTerms, canCache: false})
    ),
    takeLeading(
      ActionType.FetchMoreRedDotStatus,
      makeFetchSaga({fetchSaga: fetchMoreRedDotStatus, canCache: false})
    ),
    takeLeading(
      ActionType.FetchMyNewsList,
      makeFetchSaga({fetchSaga: fetchMyNewsList, canCache: false})
    ),
    takeLeading(
      ActionType.FetchWaitfreeList,
      makeFetchSaga({fetchSaga: fetchWaitfreeList, canCache: false})
    ),
    takeLeading(
      ActionType.FetchMyNewsReceive,
      makeFetchSaga({fetchSaga: fetchMyNewsReceive, canCache: false})
    ),
    takeLeading(
      ActionType.FetchDeleteWaitfree,
      makeFetchSaga({fetchSaga: fetchDeleteWaitfree, canCache: false})
    ),
    takeLeading(
      ActionType.FetchCashHistory,
      makeFetchSaga({fetchSaga: fetchCashHistory, canCache: false})
    ),
    takeLeading(
      ActionType.FetchTicketHistory,
      makeFetchSaga({fetchSaga: fetchTicketHistory, canCache: false})
    ),
    takeLeading(
      ActionType.FetchDaumCashHistory,
      makeFetchSaga({fetchSaga: fetchDaumCashHistory, canCache: true})
    ),
  ]);
}
